export const contactDetailsSelectors = {
  getContactDetails: state => state.contactDetails.contactDetails,
  getFederalPositions: state => state.contactDetails.federalPositions,
  getPositionTerms: state => state.contactDetails.positionTerms,
  isAddingLocation: state => state.contactDetails.isAddingLocation,
  isContactFetching: state => state.contactDetails.isContactFetching,
  isPositionsFetching: state => state.contactDetails.isPositionsFetching,
  isTermsFetching: state => state.contactDetails.isTermsFetching,
};
